enum BannerEvents {
  BannerClicked = 'banner_tap',
  BannerDisplayed = 'banner_show',
  BannerPopupDisplayed = 'banner_popup_show',
  BannerPopupClicked = 'banner_popup_tap',
}

export default BannerEvents
